import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import AndroidFilter from '../../AppAssets/Icons/svg/AndroidFilter';
import IosTopBar from '../../AppAssets/Icons/svg/IosTopBar';
import AndroidTopBar from '../../AppAssets/Icons/svg/AndroidTopBar';
import IosFilter from '../../AppAssets/Icons/svg/IosFilter';
import DownArrow from '../../AppAssets/Icons/svg/DownArrow';
import AndroidDownArrow from '../../AppAssets/Icons/svg/AndroidDownArrow';
import placeholder1 from '../../AppAssets/Icons/Girl1.png';
import placeholder2 from '../../AppAssets/Icons/Guy3.png';
import placeholder3 from '../../AppAssets/Icons/Girl3.jpg';
import androidHome from '../../AppAssets/Icons/android-home.png';
import androidInfo from '../../AppAssets/Icons/android-account.png';
import androidReserve from '../../AppAssets/Icons/android-reserve.png';
import androidBuy from '../../AppAssets/Icons/android-buy.png';
import androidBottom from '../../AppAssets/Icons/androidBottom.png';

const Schedule = memo(({ device }) => {
    const {
        class1,
        class2,
        class3,
        instructor1,
        instructor1Photo,
        instructor2,
        instructor2Photo,
        instructor3,
        instructor3Photo,
        studio1,
        studio2,
        studio3,
        region,
    } = useSelector(state => state.appState);

    return (
        <div>
            <div className={device === 'Android' ? 'view view-schedule view-android' : 'view view-schedule'}>
                {/* <!-- header   --> */}
                <div className="schedule-header">
                    {device !== 'Android' && <IosTopBar />}
                    {device === 'Android' && <AndroidTopBar />}
                    <div className="region-row">
                        <span id="region">
                            {region || 'Washington DC'}
                            {' '}
                            {device === 'Android' ? <AndroidDownArrow /> : <DownArrow />}
                            {' '}
                        </span>
                        {device !== 'Android' && <IosFilter />}
                    </div>
                    <div className="schedule-row">
                        <div className="schedule-day schedule-selected">
                            <h2>15</h2>
                            <p>Mon</p>
                        </div>
                        <div className="schedule-day">
                            <h2>16</h2>
                            <p>Tue</p>
                        </div>
                        <div className="schedule-day">
                            <h2>17</h2>
                            <p>Wed</p>
                        </div>
                        <div className="schedule-day">
                            <h2>18</h2>
                            <p>Thu</p>
                        </div>
                        <div className="schedule-day">
                            <h2>19</h2>
                            <p>Fri</p>
                        </div>
                        <div className="schedule-day">
                            <h2>20</h2>
                            <p>Sat</p>
                        </div>
                        <div className="schedule-day">
                            <h2>21</h2>
                            <p>Sun</p>
                        </div>
                    </div>
                </div>
                {/* <!--   main content area --> */}
                <section className="schedule-content">
                    <div className="schedule-content-date">
                        <p>Monday, June 15</p>
                    </div>
                    {device === 'Android' && (
                        <div className="schedule-content-filter">
                            <AndroidFilter />
                            Filter
                        </div>
                    ) }
                    {/* <!-- schedule items --> */}
                    <div className="schedule-content-item">
                        <div className="schedule-content-item_left">
                            <h2 className="label-1">9:00 am</h2>
                            <img src={instructor1Photo || placeholder1} alt="" />
                        </div>

                        <div className="schedule-content-item_right">
                            <div>
                                <h2 className="label-1 class-1">{class1 || 'Arms & Abs Workout'}</h2>
                            </div>
                            <div className="schedule-content-item_right_bottom">
                                <div>
                                    <p className="label-2">{instructor1 || 'Kara T.'}</p>
                                    <p className="label-2 studio-1">{studio1 || 'Dupont'}</p>
                                    <p className="label-4">45 mins.</p>
                                </div>
                                <div className="">
                                    <button type="button" className="btn-primary">Reserve</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="schedule-content-item">
                        <div className="schedule-content-item_left">
                            <h2 className="label-1">10:00 am</h2>
                            <img src={instructor2Photo || placeholder2} alt="" />
                        </div>

                        <div className="schedule-content-item_right">
                            <div>
                                <h2 className="label-1 class-1">{class2 || 'Arms & Abs Workout'}</h2>
                            </div>
                            <div className="schedule-content-item_right_bottom">
                                <div>
                                    <p className="label-2 instructor-2">{instructor2 || 'John S.'}</p>
                                    <p className="label-2 studio-1">{studio1 || 'Dupont'}</p>
                                    <p className="label-4">45 mins.</p>
                                </div>
                                <div className="">
                                    <button type="button" className="btn-secondary">Reserved</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="schedule-content-item">
                        <div className="schedule-content-item_left">
                            <h2 className="label-1">11:00 am</h2>
                            <img src={instructor3Photo || placeholder3} alt="" />
                        </div>

                        <div className="schedule-content-item_right">
                            <div>
                                <h2 className="label-1 class-3">{class3 || 'Arms & Abs Workout'}</h2>
                            </div>
                            <div className="schedule-content-item_right_bottom">
                                <div>
                                    <p className="label-2 instructor-3">{instructor3 || 'Amanda R.'}</p>
                                    <p className="label-2 studio-2">{studio2 || studio1 || 'Capitol Hill'}</p>
                                    <p className="label-4">45 mins.</p>
                                </div>
                                <div className="">
                                    <button type="button" className="btn-primary">Reserve</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="schedule-content-item">
                        <div className="schedule-content-item_left">
                            <h2 className="label-1">1:00 pm</h2>
                            <img src={instructor1Photo || placeholder1} alt="" />
                        </div>

                        <div className="schedule-content-item_right">
                            <div>
                                <h2 className="label-1 class-1">{class1 || 'Arms & Abs Workout'}</h2>
                            </div>
                            <div className="schedule-content-item_right_bottom">
                                <div>
                                    <p className="label-2 instructor-1">{instructor1 || 'Kara T.'}</p>
                                    <p className="label-2 studio-3">{studio3 || studio1 || 'Dupont'}</p>
                                    <p className="label-4">45 mins.</p>
                                </div>
                                <div className="">
                                    <button type="button" className="btn-waitlist">Waitlist Only</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="schedule-content-item">
                        <div className="schedule-content-item_left">
                            <h2 className="label-1">2:00 pm</h2>
                            <img src={instructor2Photo || placeholder2} alt="" />
                        </div>

                        <div className="schedule-content-item_right">
                            <div>
                                <h2 className="label-1 class-2">{class2 || 'Arms & Abs Workout'}</h2>
                            </div>
                            <div className="schedule-content-item_right_bottom">
                                <div>
                                    <p className="label-2 instructor-2">{instructor2 || 'John S.'}</p>
                                    <p className="label-2 studio-2">{studio2 || studio1 || 'Capitol Hill'}</p>
                                    <p className="label-4">45 mins.</p>
                                </div>
                                <div className="">
                                    <button type="button" className="btn-primary">Reserve</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                {/* <!-- Nav Bar   --> */}
                <div className="navBar navBar-Schedule">
                    {device === 'Android' && <img src={androidHome} alt="Home" border="0" />}
                    {device === 'Android' && <img src={androidReserve} alt="Reserve" border="0" />}
                    {device === 'Android' && <img src={androidBuy} alt="Buy" border="0" />}
                    {device === 'Android' && <img src={androidInfo} alt="Account" border="0" />}

                    {device !== 'Android'
                    && (
                        <svg className="homeIcon" width="28" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.258789 13.243C0.258789 13.7836 0.680664 14.2977 1.39258 14.2977C1.76172 14.2977 2.06494 14.1 2.3418 13.8759L4.05566 12.4257V25.0028C4.05566 26.8485 5.1499 27.9164 7.03516 27.9164H24.8726C26.7446 27.9164 27.8389 26.8485 27.8389 25.0028V12.3334L29.6714 13.8759C29.9351 14.1 30.2383 14.2977 30.6074 14.2977C31.2271 14.2977 31.728 13.9154 31.728 13.2826C31.728 12.8871 31.5962 12.6234 31.3193 12.3861L27.8389 9.45935V4.00134C27.8389 3.42126 27.4697 3.05212 26.8896 3.05212H25.479C24.9121 3.05212 24.5298 3.42126 24.5298 4.00134V6.67761L17.5952 0.850464C16.6196 0.0198975 15.4067 0.0198975 14.418 0.850464L0.680664 12.3861C0.390625 12.6234 0.258789 12.9398 0.258789 13.243ZM19.8101 16.9608C19.8101 16.3544 19.4146 15.9589 18.8081 15.9589H13.2183C12.5986 15.9589 12.2031 16.3544 12.2031 16.9608V25.7938H7.4834C6.63965 25.7938 6.17822 25.3192 6.17822 24.4623V10.6459L15.5386 2.80164C15.8286 2.53796 16.1846 2.53796 16.4746 2.80164L25.7163 10.5536V24.4623C25.7163 25.3192 25.2549 25.7938 24.4243 25.7938H19.8101V16.9608Z" />
                        </svg>
                    )}

                    {device !== 'Android' && (
                        <svg className="icon-schedule" width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.99512 24.6367H23.0039C25.7593 24.6367 27.1304 23.2656 27.1304 20.5498V4.45264C27.1304 1.73682 25.7593 0.365723 23.0039 0.365723H4.99512C2.23975 0.365723 0.855469 1.72363 0.855469 4.45264V20.5498C0.855469 23.2788 2.23975 24.6367 4.99512 24.6367ZM4.79736 22.5142C3.62402 22.5142 2.97803 21.8945 2.97803 20.6685V8.23633C2.97803 7.02344 3.62402 6.39062 4.79736 6.39062H23.1753C24.3486 6.39062 25.0078 7.02344 25.0078 8.23633V20.6685C25.0078 21.8945 24.3486 22.5142 23.1753 22.5142H4.79736ZM11.4155 11.1235H12.1934C12.6548 11.1235 12.813 10.9917 12.813 10.5303V9.75244C12.813 9.29102 12.6548 9.146 12.1934 9.146H11.4155C10.9541 9.146 10.7959 9.29102 10.7959 9.75244V10.5303C10.7959 10.9917 10.9541 11.1235 11.4155 11.1235ZM15.8057 11.1235H16.5703C17.0317 11.1235 17.1899 10.9917 17.1899 10.5303V9.75244C17.1899 9.29102 17.0317 9.146 16.5703 9.146H15.8057C15.3311 9.146 15.186 9.29102 15.186 9.75244V10.5303C15.186 10.9917 15.3311 11.1235 15.8057 11.1235ZM20.1826 11.1235H20.9604C21.4219 11.1235 21.5669 10.9917 21.5669 10.5303V9.75244C21.5669 9.29102 21.4219 9.146 20.9604 9.146H20.1826C19.7212 9.146 19.563 9.29102 19.563 9.75244V10.5303C19.563 10.9917 19.7212 11.1235 20.1826 11.1235ZM7.03857 15.4346H7.81641C8.27783 15.4346 8.42285 15.3027 8.42285 14.8413V14.0635C8.42285 13.6021 8.27783 13.4702 7.81641 13.4702H7.03857C6.57715 13.4702 6.41895 13.6021 6.41895 14.0635V14.8413C6.41895 15.3027 6.57715 15.4346 7.03857 15.4346ZM11.4155 15.4346H12.1934C12.6548 15.4346 12.813 15.3027 12.813 14.8413V14.0635C12.813 13.6021 12.6548 13.4702 12.1934 13.4702H11.4155C10.9541 13.4702 10.7959 13.6021 10.7959 14.0635V14.8413C10.7959 15.3027 10.9541 15.4346 11.4155 15.4346ZM15.8057 15.4346H16.5703C17.0317 15.4346 17.1899 15.3027 17.1899 14.8413V14.0635C17.1899 13.6021 17.0317 13.4702 16.5703 13.4702H15.8057C15.3311 13.4702 15.186 13.6021 15.186 14.0635V14.8413C15.186 15.3027 15.3311 15.4346 15.8057 15.4346ZM20.1826 15.4346H20.9604C21.4219 15.4346 21.5669 15.3027 21.5669 14.8413V14.0635C21.5669 13.6021 21.4219 13.4702 20.9604 13.4702H20.1826C19.7212 13.4702 19.563 13.6021 19.563 14.0635V14.8413C19.563 15.3027 19.7212 15.4346 20.1826 15.4346ZM7.03857 19.7588H7.81641C8.27783 19.7588 8.42285 19.6138 8.42285 19.1523V18.3745C8.42285 17.9131 8.27783 17.7812 7.81641 17.7812H7.03857C6.57715 17.7812 6.41895 17.9131 6.41895 18.3745V19.1523C6.41895 19.6138 6.57715 19.7588 7.03857 19.7588ZM11.4155 19.7588H12.1934C12.6548 19.7588 12.813 19.6138 12.813 19.1523V18.3745C12.813 17.9131 12.6548 17.7812 12.1934 17.7812H11.4155C10.9541 17.7812 10.7959 17.9131 10.7959 18.3745V19.1523C10.7959 19.6138 10.9541 19.7588 11.4155 19.7588ZM15.8057 19.7588H16.5703C17.0317 19.7588 17.1899 19.6138 17.1899 19.1523V18.3745C17.1899 17.9131 17.0317 17.7812 16.5703 17.7812H15.8057C15.3311 17.7812 15.186 17.9131 15.186 18.3745V19.1523C15.186 19.6138 15.3311 19.7588 15.8057 19.7588Z" />
                        </svg>
                    )}

                    {device !== 'Android' && (
                        <svg className="icon-buy" width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.99316 25.4414H18.3608C20.5459 25.4414 21.8276 24.1719 21.8276 21.6572V9.02295C21.8276 6.5083 20.5337 5.23877 17.9946 5.23877H16.0415C15.9805 2.67529 13.7466 0.490234 10.9878 0.490234C8.229 0.490234 5.99512 2.67529 5.93408 5.23877H3.99316C1.44189 5.23877 0.160156 6.49609 0.160156 9.02295V21.6572C0.160156 24.1841 1.44189 25.4414 3.99316 25.4414ZM10.9878 2.3457C12.709 2.3457 14.0151 3.63965 14.0762 5.23877H7.89941C7.96045 3.63965 9.2666 2.3457 10.9878 2.3457ZM4.01758 23.4761C2.79688 23.4761 2.12549 22.8291 2.12549 21.5596V9.12061C2.12549 7.85107 2.79688 7.2041 4.01758 7.2041H17.958C19.1665 7.2041 19.8623 7.85107 19.8623 9.12061V21.5596C19.8623 22.8291 19.1665 23.4761 18.3242 23.4761H4.01758Z" />
                        </svg>
                    )}

                    {device !== 'Android' && (
                        <svg className="icon-account" width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 26.9287C21.3564 26.9287 27.4473 20.8247 27.4473 13.4814C27.4473 6.125 21.3433 0.0341797 13.9868 0.0341797C6.64355 0.0341797 0.552734 6.125 0.552734 13.4814C0.552734 20.8247 6.65674 26.9287 14 26.9287ZM14 17.9771C10.0449 17.9771 6.98633 19.3877 5.65479 20.9697C3.875 18.9922 2.80713 16.3687 2.80713 13.4814C2.80713 7.25879 7.76416 2.27539 13.9868 2.27539C20.2095 2.27539 25.1929 7.25879 25.2061 13.4814C25.2192 16.3687 24.1382 18.9922 22.3584 20.9829C21.0269 19.4009 17.9683 17.9771 14 17.9771ZM14 15.7358C16.5312 15.7622 18.522 13.6001 18.522 10.7656C18.522 8.10254 16.5312 5.8877 14 5.8877C11.4688 5.8877 9.46484 8.10254 9.47803 10.7656C9.49121 13.6001 11.4688 15.7095 14 15.7358Z" />
                        </svg>
                    )}

                </div>
                {device === 'Android' && <img src={androidBottom} className="android-buttons" alt="" />}
            </div>

        </div>
    );
});

Schedule.displayName = 'Schedule';

export default Schedule;
